import AppContext from 'App/AppContext';
import { IPIconButton, IPSeparator, IPText } from 'baseComponents';
import { IPPersona, IPPersonaSize } from 'baseComponents/Persona/IPPersona';
import { IPStack } from 'baseComponents/Stack/IPStack';
import RichTextReadOnly from 'components/Text/RichTextReadOnly';
import { deleteIcon, globalStackTokensGapSmall } from 'globalStyles';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

interface IPendingCommentProps {
  comment: string;
  onRemove: () => void;
}

//A message written before its entity exists. It is only held client-side until the entity is saved.
const PendingComment = (props: IPendingCommentProps) => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation(['commentTrail']);

  return (
    <IPStack>
      <IPStack horizontal tokens={globalStackTokensGapSmall}>
        <IPStack.Item>
          <IPPersona
            imageUrl={appContext.user.getPhotoURLObj()}
            text={appContext.user.name}
            hidePersonaDetails={true}
            size={IPPersonaSize.size24}
          />
        </IPStack.Item>
        <IPStack.Item grow>
          <IPStack>
            <IPStack horizontal tokens={globalStackTokensGapSmall} verticalAlign="center">
              <IPStack.Item>
                <IPText block variant="small">
                  <strong>{appContext.user.name}</strong>
                </IPText>
              </IPStack.Item>
              <IPStack.Item>
                <IPText block variant="small">
                  <em>{t('commentTrail:NotSavedYet')}</em>
                </IPText>
              </IPStack.Item>
              <IPStack.Item>
                <IPIconButton
                  styles={{ root: { height: 16 } }}
                  iconProps={deleteIcon}
                  title={t('commentTrail:Remove')}
                  onClick={props.onRemove}
                />
              </IPStack.Item>
            </IPStack>
            <IPStack.Item>
              <RichTextReadOnly
                html={props.comment}
                hideBorder={true}
                linkify={true}
                stripParagraph={true}
                maxHeight={-1}
              />
            </IPStack.Item>
          </IPStack>
        </IPStack.Item>
      </IPStack>
      <IPSeparator />
    </IPStack>
  );
};

export default PendingComment;
